import {
  getRamsDashboard,
  getRamsActive,
  getRamsSettings,
  getRamsProjectsList,
  getRamsDocuments,
  createRamsDocument,
  updateRamsDocument,
  deleteRamsDocument,
  toggleRamsDocumentActive,
} from '../../../HttpRequests/ramsControlCentre'
import { getSettings } from '../../../HttpRequests/settings'

export const fetchDashboard = () => getRamsDashboard()

export const fetchActiveRams = (params) => getRamsActive(params)

export const fetchSettings = () => {
  return getSettings({
    params: {
      'filter[group]': 'RAMS',
      'page[size]': 100
    }
  })
}

export const fetchProjectsList = () => getRamsProjectsList()

export const fetchDocuments = (params) => getRamsDocuments(params)

export const uploadDocument = (formData) => createRamsDocument(formData)

export const editDocument = (id, formData) => updateRamsDocument(id, formData)

export const removeDocument = (id) => deleteRamsDocument(id)

export const toggleDocumentActive = (id) => toggleRamsDocumentActive(id)
